import { async } from '@angular/core/testing';
import * as uuid from 'uuid';

function createUUID(): string {
    return uuid.v4();
}

export function detectUser(): void {
    let userId = localStorage.getItem('userId');
    if (!userId) {
        setUserId();
    }
}

export function getUserId(): string {
    return localStorage.getItem('userId');
}

export function setUserId(): void {
    localStorage.setItem('userId', createUUID())
}